export const getImpersonationUrl = ({
  brand,
  token,
  refreshToken,
  expiration,
}) => {
  const configuredHost = {
    GENNEV: process.env.REACT_APP_GENNEV_FRONT_URL,
    VIRTUAL_CLINIC: process.env.REACT_APP_VIRTUAL_CLINIC_FRONT_URL,
  }[brand];

  if (!configuredHost) {
    throw new Error(
      `No frontend host configured for brand: ${brand || "unknown"}`,
    );
  }

  const url = new URL("/auth/impersonate", configuredHost);
  url.search = new URLSearchParams({
    token,
    refreshToken,
    expiration: String(expiration),
  }).toString();

  return url.toString();
};
